import * as api from './api';
import * as docPartnerApi from 'features/document/edit/partners/api';
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from 'actions/actionCreators/httpActions';
import * as types from './actionTypes';
import * as eventTypes from './eventTypes';
import { getBankAccountsIsLoaded } from './selectors';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadOfferPartnerBankAccounts(partnerId, documentId, siteId) {
  return async (dispatch, getState) => {
    const isLoaded = getBankAccountsIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }
    try {
      const partnerBankAccounts = await dispatch(sendHttpRequest(docPartnerApi.getPartnerBankAccounts(partnerId, documentId, siteId)));
      dispatch({
        type: types.LOAD_PARTNER_BANK_ACCOUNTS_SUCCEEDED,
        id: partnerId,
        payload: partnerBankAccounts
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadBanks(search) {
  //no redux cache
  return () => api.getBanks(search);
}

export function saveBankAccounts(documentId, siteId, partnerId, bankAccounts) {
  return async dispatch => {
    dispatch({
      type: types.UPDATE_PARTNER_BANK_ACCOUNTS_STARTED,
      payload: bankAccounts,
      partnerId: partnerId
    });
    try {
      let event = await dispatch(
        sendHttpCommandAndWaitForEvent(docPartnerApi.saveBankAccounts(documentId, siteId, partnerId, bankAccounts), 'saveBankAccounts', [
          eventTypes.PARTNER_BANK_ACCOUNTS_UPDATED
        ])
      );
      if (event.ok) {
        dispatch({
          type: types.UPDATE_PARTNER_BANK_ACCOUNTS_SUCCEEDED,
          partnerId
        });
      } else {
        dispatch(showError(event.error.message));
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
